import { Component } from "@angular/core";

/**
 * Punto y tallo de la «i» (mismo trazo que icon-i.svg, sin el círculo exterior).
 * Para error general: fondo rojo en el contenedor + esta pieza en blanco.
 */
@Component({
  selector: "icon-info-stem-tramite",
  templateUrl: "./icon-i-stem-dot.svg",
  standalone: true,
  styles: [
    `
      :host {
        display: block;
        color: inherit;
        line-height: 0;
      }
    `,
  ],
})
export class InfoStemTramiteIconComponent {}
